import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const SearchIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.97683 0C4.0298 0 0 4.02842 0 8.97378C0 13.9191 4.0298 17.9554 8.97683 17.9554C11.0899 17.9554 13.0332 17.2151 14.5691 15.9861L18.3083 19.722C18.497 19.9029 18.749 20.0026 19.0104 19.9999C19.2718 19.9973 19.5217 19.8924 19.7067 19.7078C19.8916 19.5231 19.9969 19.2735 19.9999 19.0122C20.003 18.7509 19.9035 18.4988 19.7229 18.3099L15.9837 14.572C17.2142 13.0343 17.9556 11.0885 17.9556 8.97378C17.9556 4.02842 13.9238 0 8.97683 0ZM8.97683 1.99463C12.8455 1.99463 15.9584 5.10641 15.9584 8.97378C15.9584 12.8412 12.8455 15.9608 8.97683 15.9608C5.10813 15.9608 1.99528 12.8412 1.99528 8.97378C1.99528 5.10641 5.10813 1.99463 8.97683 1.99463Z"
        fill="currentColor"
      />
    </svg>
  )
})

SearchIcon.displayName = 'SearchIcon'
